let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Jr6P")).then(() => parcelRequire('i53Hg'));